<script setup>
import { computed } from "vue";

const props = defineProps({
	modelValue: {
		type: Boolean,
		required: true,
	},
});
const emit = defineEmits("update:modelValue");
const showSkeleton = computed({
	get: () => props.modelValue,
	set: v => emit("update:modelValue", v),
});
</script>

<template>
	<template v-if="showSkeleton">
		<div
			class="skeleton-box w-100 mb-3"
			style="height: 100px; background-color: rgba(190, 190, 190, 0.2);"
		></div>
		<div
			class="skeleton-box w-100 mb-3"
			style="height: 100px; background-color: rgba(190, 190, 190, 0.2);"
		></div>
		<div
			class="skeleton-box w-100"
			style="height: 100px; background-color: rgba(190, 190, 190, 0.2);"
		></div>
	</template>
	<slot v-else></slot>
</template>
